/* eslint-disable handle-callback-err */
import ExecutionEnvironment from 'exenv'
import moment from 'moment'
import {
  DATE_FORMAT,
  HOTEL_PRODUCT_TYPE,
  FLIGHT_PRODUCT_TYPE,
  VACATION_PACKAGE_PRODUCT_TYPE
} from '../constants/Constants'
import { isSessionStorageAvailable } from './session-storage-check'
// import ajax from '../utils/ajax'

// const RecentSearchActions = 'RecentSearchActions'
const RECENT_SEARCH_KEY = 'mostRecentSearch'
const RECENT_SEARCH_TAB_KEY = 'mostRecentSearchTab'

class RecentSearchHelper {
  saveHotelSearch (searchData) {
    const hotelSearchData = {
      product: HOTEL_PRODUCT_TYPE,
      startDate: searchData.checkInDate || '',
      endDate: searchData.checkOutDate || '',
      destination: searchData.location,
      numberOfRooms: searchData.roomCount
    }

    if (searchData.guests) {
      Object.assign(hotelSearchData, {
        adultCount: searchData.guests.adultCount,
        childrenCount: searchData.guests.childrenCount,
        childrenAges: searchData.guests.childrenAges
      })
    }

    saveSearch(hotelSearchData)
  }

  saveFlightSearch (searchData) {
    const tripType = searchData.tripType
    const flightSearchData = {
      product: FLIGHT_PRODUCT_TYPE,
      tripType,
      numberOfAdults: searchData.adultCount,
      numberOfChildren: searchData.childCount,
      cabinClass: searchData.cabinClass || 'ECO',
      preferredAirline: searchData.preferredAirline
    }
    let flight

    switch (tripType) {
      case 'MD':
        flightSearchData.flights = searchData.multiDestFlights.map(flight => {
          return {
            origin: flight.departureLocation,
            destination: flight.arrivalLocation,
            startDate: moment(flight.departureDate).format(DATE_FORMAT)
          }
        })
        break
      case 'RT':
        flight = searchData.roundTripFlight
        flightSearchData.startDate = moment(flight.departureDate).format(
          DATE_FORMAT
        )
        flightSearchData.endDate = moment(flight.returnDate).format(DATE_FORMAT)
        flightSearchData.origin = flight.departureLocation
        flightSearchData.destination = flight.arrivalLocation
        break
      case 'OW':
        flight = searchData.oneWayFlight
        flightSearchData.startDate = moment(flight.departureDate).format(
          DATE_FORMAT
        )
        flightSearchData.endDate = ''
        flightSearchData.origin = flight.departureLocation
        flightSearchData.destination = flight.arrivalLocation
        break
    }

    saveSearch(flightSearchData)
  }

  saveVPSearch (searchData) {
    const tripType = searchData.tripType
    const vpSearchData = {
      product: VACATION_PACKAGE_PRODUCT_TYPE,
      tripType,
      origin: searchData.departureLocation,
      destination: searchData.arrivalLocation,
      startDate: moment(searchData.departureDate).format(DATE_FORMAT),
      endDate: moment(searchData.returnDate).format(DATE_FORMAT),
      numberOfRooms: searchData.rooms,
      numberOfAdults: searchData.adultCount,
      numberOfChildren: searchData.childCount
    }

    saveSearch(vpSearchData)
  }

  getMostRecentSearch () {
    let mostRecentSearch

    try {
      if (ExecutionEnvironment.canUseDOM && isSessionStorageAvailable()) {
        const storageItem = isSessionStorageAvailable()
          ? window.sessionStorage.getItem(RECENT_SEARCH_TAB_KEY)
          : { HOTEL_PRODUCT_TYPE }

        if (storageItem) {
          mostRecentSearch = JSON.parse(storageItem)
          mostRecentSearch.startDate = getMomentForDate(
            mostRecentSearch.startDate
          )
          mostRecentSearch.endDate = getMomentForDate(mostRecentSearch.endDate)
          if (mostRecentSearch.flights && mostRecentSearch.flights.length > 0) {
            for (let flight of mostRecentSearch.flights) {
              flight.startDate = getMomentForDate(flight.startDate)
            }
          }
        }
      }
    } catch (ex) {
      // nothing to do here for now
    }

    return mostRecentSearch
  }
}

function saveSearch (searchData) {
  try {
    if (isSessionStorageAvailable()) {
      window.localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(searchData))
    }
  } catch (ex) {
    // nothing to do here right now
    // This pretty much just catches Safari private mode errors because it doesn't have localStorage
  }
}

function getMomentForDate (date) {
  // If date exists then create moment
  if (date) {
    return moment(date, [DATE_FORMAT, moment.ISO_8601])
  }

  // If date does not exist then return it as is
  return date
}
export const RECENT_SEARCH_HELPER = new RecentSearchHelper()
